(function() {
    'use strict';

    angular
        .module("showcaseApp")
        .component("styledCardSliderButton", {
            templateUrl: "app/components/styled-card-slider-button/styled-card-slider-button.html",
            controller: StyledCardSliderButtonController,
            bindings: {
                model: "=",
                name: "@",
                listClass: "@",
                cardClass: "@",
                label: "@",
                subtitle: "@",
                required: "<",
                errors: "<",
                form: "<",
                onChange: "&",
                readonly: "<",
                iconClass: "@",
                tagLabel: "@",
                learnMore: "@",
                tooltip: "@",
                onLearnMore: "&",
            },
            transclude: true
        })
        .directive("toggleChange", function () {
            return {
                restrict: "A",
                link: function (scope, elem, attrs) {
                    scope.$watch(attrs["ngModel"], function (v) {
                        if (scope.$ctrl.onChange) {
                            scope.$ctrl.onChange({ value: v });
                        }
                    });
                },
            };
        });

    /** @ngInject */
    function StyledCardSliderButtonController() {
        var $ctrl = this;

        $ctrl.$onInit = function() {
            $ctrl.readonly = $ctrl.readonly || false;
            $ctrl.cardClass = $ctrl.cardClass || 'col-md-3 col-sm-12';
        };
    }
})();
